import React from 'react';
import { useDeliveryMode } from '@/contexts/DeliveryModeContext';
import { Truck, X } from 'lucide-react';

const DeliveryModeBanner = () => {
  const { isDeliveryMode, disableDeliveryMode, isLoading } = useDeliveryMode();

  if (isLoading || !isDeliveryMode) {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-brand-600 to-brand-700 text-white py-1.5 px-4 flex items-center justify-between shadow-sm border-b border-brand-500">
      <div className="flex items-center gap-2">
        <Truck className="w-4 h-4" />
        <span className="font-semibold text-sm">Delivery Mode Active</span>
        <span className="text-brand-100 text-xs">- Navigation restricted to delivery functions</span>
      </div>
      <button
        onClick={disableDeliveryMode}
        className="text-white hover:text-brand-100 transition-colors p-1 rounded hover:bg-brand-500"
        title="Exit Delivery Mode"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default DeliveryModeBanner;
